import React from 'react';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import * as classes from './TabsPanel.module.css';
import ValueConfigurationInsert from './ValueConfigurationInsert';
import AssignmentInsert from './AssignmentInsert';

const TabsPanel = ({
    clientAttributes,
    items,
    setItems,
    selectedAttribute,
    selectedEntity,
    setValue,
    value,
    ...props
}) => {

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <React.Fragment>
            <div className={classes.TabsContainer}>
                <Tabs
                    TabIndicatorProps={{ style: { background: 'black' }}}
                    value={value}
                    onChange={handleChange}
                >
                    <Tab className={classes.Tab} value={0} label="Look-up" />
                    {
                        selectedAttribute.name === 'region' && clientAttributes.find(item => item.name === 'region') && selectedEntity && selectedEntity.name === 'Client' ?
                            <Tab className={classes.Tab} value={1} label="Assignment" />
                            :
                            null
                    }
                    {/*<Tab className={classes.Tab} value={2} label="Universe Definition" />*/}
                    {/*<Tab className={classes.Tab} value={3} label="Attribute Definition" />*/}
                </Tabs>
            </div>
            <div>
                {
                    value === 0 ?
                        <ValueConfigurationInsert
                            items={items}
                            setItems={setItems}
                            selectedAttribute={selectedAttribute}
                            selectedEntity={selectedEntity}
                        />
                        :
                        null
                }
                {
                    value === 1 ?
                        <AssignmentInsert
                            items={items}
                            setItems={setItems}
                            selectedAttribute={selectedAttribute}
                            selectedEntity={selectedEntity}
                        />
                        :
                        null
                }
                {
                    value === 2 ?
                        <div>
                            Two
                        </div>
                        :
                        null
                }
                {
                    value === 3 ?
                        <div>
                            Three
                        </div>
                        :
                        null
                }
            </div>
        </React.Fragment>
    );
};

export default TabsPanel;
